// extracted by mini-css-extract-plugin
export var active = "secondaryNavigation-module--active--91a0d";
export var navContainer = "secondaryNavigation-module--navContainer--ed6b7";
export var navItem = "secondaryNavigation-module--nav-item--26064";
export var navItems = "secondaryNavigation-module--nav-items--c4898";
export var nextButton = "secondaryNavigation-module--next-button--0646b";
export var prevButton = "secondaryNavigation-module--prev-button--c5406";
export var secondaryNavigation = "secondaryNavigation-module--secondary-navigation--a72f6";